import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={36}
            height={36}
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <path
            d="M21.333 22.167L25.5 18m0 0l-4.167-4.167M25.5 18h-10m0-7.5h-1c-1.4 0-2.1 0-2.635.273a2.5 2.5 0 00-1.092 1.092C10.5 12.4 10.5 13.1 10.5 14.5v7c0 1.4 0 2.1.273 2.635a2.5 2.5 0 001.092 1.092c.535.273 1.235.273 2.635.273h1"
            stroke={props.isHover ? "#B42318" : "#667085"}
            strokeWidth={1.66667}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        </svg>
    )
}
  
  export default SvgComponent